import {useContext} from 'react'
import {CustomerReportContext} from '../../context'
import {DynamicTable} from '../../../../components/DynamicTable'
import {CUSTOMER_GROUP_REPORT_COLUMNS} from '../../utils'
import CustomerGroupReportRow from './CustomerGroupReportRow'
import {parseCustomerGroupReportRow} from '../../parsings'
import {formatPrice} from '../../../../utils/common'
import CustomerGroupTableReportHeader from '../header/CustomerGroupTableReportHeader'

const CustomerGroupReportTable = () => {
  const {
    customerGroupData,
    isCustomerGroupLoading,
    customerGroupReportFilters,
    onSortingChangeCustomerGroupReport,
  } = useContext(CustomerReportContext)

  return (
    <div className='card border mb-10'>
      <div className='card-body p-7'>
        <CustomerGroupTableReportHeader />
        <DynamicTable
          data={customerGroupData}
          sortableColumns={CUSTOMER_GROUP_REPORT_COLUMNS}
          loading={isCustomerGroupLoading}
          TableRow={CustomerGroupReportRow}
          noDataMessage='No customer groups found'
          tableClass='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-2'
          rowParsingFunction={parseCustomerGroupReportRow}
          filters={customerGroupReportFilters}
          onSortingChange={onSortingChangeCustomerGroupReport}
          tableFooter={({columnTotals}: any) => (
            <tfoot className='border-top border-gray-200 text-dark fw-bolder'>
              <tr>
                <td>TOTAL</td>
                <td>{columnTotals?.total_orders}</td>
                <td>{formatPrice(columnTotals.total_cost, false)}</td>
                <td>{formatPrice(columnTotals.total_revenue, false)}</td>
                <td></td>
                <td>{formatPrice(columnTotals.total_profit, false)}</td>
              </tr>
            </tfoot>
          )}
        />
      </div>
    </div>
  )
}

export default CustomerGroupReportTable
